import * as z from "zod";

export const deleteProductKnowledgeEdit = {
  name: "deleteProductKnowledgeEdit" as const,
  input: z.object({
    /** Stringified bigint id of the row in notion_product_knowledge_edit. */
    id: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
